import styled from 'styled-components'
import { ModalFooter } from 'react-bootstrap'

const ModalFooterStyled = styled(ModalFooter)`
  padding: 0.4rem 3rem 0.4rem 0;
`

export default ModalFooterStyled
